import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=0b41c7cd&scoped=true"
import script from "./theme.vue?vue&type=script&lang=js"
export * from "./theme.vue?vue&type=script&lang=js"
import style0 from "./theme.vue?vue&type=style&index=0&id=0b41c7cd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b41c7cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b41c7cd')) {
      api.createRecord('0b41c7cd', component.options)
    } else {
      api.reload('0b41c7cd', component.options)
    }
    module.hot.accept("./theme.vue?vue&type=template&id=0b41c7cd&scoped=true", function () {
      api.rerender('0b41c7cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bigScreen/components/theme.vue"
export default component.exports